<section class="main-container global-search">
  <app-page-header [headerTitle]="('Search Results' | translate) + ': ' + searchValue" [showBackButtonOnMobileOnly]="true" prefixIconName="search"></app-page-header>

  <div class="global-search__results">
    @if (!isLoading) {
      @if (searchResults) {
        @for (section of searchSections; track section.title) {
          @if (searchResults[section.key]?.length > 0) {
            <div class="card global-search__results__category_wrapper">
              <div (click)="toggleSection(section)" class="global-search__results__category_wrapper__header" [class.mb-24]="section.isExpanded">
                <h3>
                  {{ section.title | translate }}
                  <app-badge [cssStyle]="{ marginLeft: '10px' }" [text]="searchResults[section.key]?.length" type="success"></app-badge>
                </h3>
                <app-icon [iconName]="section.isExpanded ? 'chevron-up' : 'chevron-down'"></app-icon>
              </div>
              @if (section.isExpanded) {
                <div class="global-search__results__category_wrapper__category-items-list">
                  @for (result of searchResults[section.key]; track result) {
                    <div (click)="handleItemClick(result, section)" class="card global-search__results__item">
                      @if (result.imageUrl) {
                        <div class="item__image background-loading">
                          <img [src]="result.imageUrl" alt="" appDefaultImage />
                        </div>
                      }
                      <div class="item__content">
                        <app-badge [text]="section.badgeText | translate"></app-badge>
                        <p class="item__content__title">{{ getTitle(result, section.key) | truncateText: 40 }}</p>
                        @if (getDescription(result, section.key)) {
                          <p [innerHTML]="getDescription(result, section.key) | truncateText: 100" class="item__content__description"></p>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      } @else {
        <div class="noRecord">
          <p translate>No record found</p>
        </div>
      }
    } @else {
      @for (_ of [].constructor(15); let i = $index; track i + (i + 1) * 1000) {
        <ngx-skeleton-loader [theme]="{ borderRadius: '6px', height: '65px', marginBottom: '0' }"></ngx-skeleton-loader>
      }
    }
  </div>
</section>
